import { createStyles } from '@mantine/core';

const usePackageDrawerStyles = createStyles(() => ({
  content: {
    height: '100%',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr auto 1fr',
  },
  rightColumn: {
    overflowY: 'scroll',
  },
}));

export default usePackageDrawerStyles;
